module.exports = __webpack_public_path__ + "static/media/expand-arrows-alt.da1685ae.svg";